export default {
  "content": "<path d=\"M24 41.586V20h-2v21.586l-6.293-6.293-1.414 1.414 8 8 .707.707.707-.707 8-8-1.414-1.414L24 41.586zM35 33c6.052 0 11-4.948 11-11s-3.966-10.996-10.019-10.996C35.332 3.757 30.287 0 23 0c-7.752 0-13 5.248-13 13v1.012c-5.022 0-9.662 3.891-9.998 8.921L0 32v1h16v-2H2v-8c.263-3.916 3.535-7 7.5-7H12v-3c0-6.648 4.352-11 11-11 6.248 0 10.447 3.87 11.004 10.09l.082.91H35c4.948 0 9 4.052 9 9s-4.052 9-9 9h-5v2h5z\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "width": "46",
    "height": "46",
    "viewBox": "0 0 46 46",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};